

































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import DateTimeUtils from '@/lib/dateTimeUtils';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobBrowseWorkersSearchCriteria from '@/components/JobWorkers/JobBrowseWorkersSearchCriteria.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerProfilePermSummary from '@/components/Workers/WorkerProfilePermSummary.vue';
import JobBrowseWorkersShortlist from '@/components/JobWorkers/JobBrowseWorkersShortlist.vue';
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue';

@Component({
  name: 'JobBrowseWorkers',
  components: { JobBrowseWorkersSearchCriteria, JobBrowseWorkersShortlist, WorkerProfilePermSummary, JobWorkerStatus }
})
export default class extends GiganautVue {

	page = 1;
	perPage = 8;

	existingWorker(id: string){
		for (let index = 0; index < JobDetailsModule.jobWorkersVM.jobWorkers.length; index++) {
			const jobWorker = JobDetailsModule.jobWorkersVM.jobWorkers[index];
			if (jobWorker.workerId === id) {
				return true;
			}
		}
		return false;
	}

	existingWorkerStatus(id: string){
		for (let index = 0; index < JobDetailsModule.jobWorkersVM.jobWorkers.length; index++) {
			const jobWorker = JobDetailsModule.jobWorkersVM.jobWorkers[index];
			if (jobWorker.workerId === id) {
				return jobWorker.status;
			}
		}
		return 0;
	}

	get selectedWorkerId() {
		return JobDetailsModule.browseWorkersVM.selectedWorkerId;
	}

	set selectedWorkerId(id: string) {
		JobDetailsModule.browseWorkersVM.selectedWorkerId = id;
	}

	get selectedWorker() {
		return JobDetailsModule.browseWorkersVM.selectedWorker;
	}

	get currentJob() {
		return JobDetailsModule.currentJob;
	}

	// @Watch('selectedBookingRole', { immediate: true })
    // async onSelectedBookingRoleChanged(val: BookingRoleDto, oldVal: BookingRoleDto) {
	//    await BookingDetailsModule.updateBrowseSelectedBookingRole(val);
	//    if (this.pagedWorkerProfiles.length !== 0) {
	// 		BookingDetailsModule.browseWorkersVM.selectedWorkerId = (this.pagedWorkerProfiles[0].entity.id);
	//    }
	// }
	
	get workerProfiles() {
		return JobDetailsModule.browseWorkersVM.workerProfiles;
	}

	get pagedWorkerProfiles() {
		return this.workerProfiles.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	@Watch('selectedWorkerId', { immediate: true })
    async onSelectedWorkerIdChanged(val: string, oldVal: string) {
	   if (val !== '') {
		   await JobDetailsModule.updateSelectedBrowseWorker(val);
	   }
	}
	
	async onPageChanged(input: number){
		JobDetailsModule.browseWorkersVM.selectedWorkerId = (this.pagedWorkerProfiles[0].entity.id);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}

	async updateSelectedWorkerProfileIds(val: boolean, workerProfileId: string) {
    	if (val) {
			await JobDetailsModule.addBrowseSelectedWorkerId(workerProfileId)
		} else {
			await JobDetailsModule.removeBrowseSelectedWorkerId(workerProfileId)
		}
	}
}
